export interface ItemEditorState {
  keywords: string;
  location: string;
  qty: number | string;
  tagIds: string[];
}

export const initialItemEditorState: ItemEditorState = {
  keywords: '',
  location: '',
  qty: 1,
  tagIds: [],
};

export type ItemEditorAction =
  | { type: 'setKeywords'; value: string }
  | { type: 'setLocation'; value: string }
  | { type: 'setTags'; value: string[] }
  | { type: 'setQty'; value: number | string };

export const itemEditorReducer = (
  state: ItemEditorState,
  action: ItemEditorAction,
): ItemEditorState => {
  switch (action.type) {
    case 'setKeywords':
      return { ...state, keywords: action.value };
    case 'setLocation':
      return { ...state, location: action.value };
    case 'setTags':
      return { ...state, tagIds: action.value };
    case 'setQty':
      return { ...state, qty: action.value };
  }
};
